<template>
  <section>
    <div v-if="emptyStudentList" class="class-empty-modal">
      <h1 class="class-empty-modal_heading">There Are No Students In The Class Yet</h1>
      <p class="class-empty-modal_text">Make sure you send the Unique Class Code to your students, to get them started on their projects. Once they register, they will show up here.</p>
    </div>
    <infinite-scroll distance="5">
      <ul class="student-card_container">
        <class-user-card v-for="(student, index) in studentList"
                         :key="index"
                         :student="student"
                         @goToConnectedUser="goToConnectedUser(student.userName)"
                         @editStudent="editStudent(student)"
                         @showRemoveStudentModal="showRemoveStudentModal(student)" />
      </ul>
    </infinite-scroll>
    <student-sign-up v-if="showEditStudent"
                     :currentStudent="currentStudent"
                     :editStudentByTeacher="editStudentByTeacher"
                     @doneEditStudent="doneEditStudent" />
    <modal-custom v-if="showConfirmDeleteModal"
        :hasFooter="true"
        title='Remove Student'
        text="Are you sure to remove this student from your class?"
        successText="Remove"
        cancelText="Cancel"
        @modalSuccess="removeStudent"
        @modalCancel="showConfirmDeleteModal = false" />
  </section>
</template>

<script>
import InfiniteScroll from '@/components/Controls/InfiniteScroll'
import componentState from '@/mixins/component-state'
import studentSignUp from '@/components/Modals/StudentSignUpByCode'
import ModalCustom from '@/components/Modals/Custom'
import i18n from '@/i18n'
import ClassUserCard from './ClassUserCard'

export default {
  mixins: [componentState],
  components: {
    InfiniteScroll,
    studentSignUp,
    ModalCustom,
    i18n,
    ClassUserCard
  },
  props: ['user', 'profile', 'selectedClass', 'showEditIcons'],
  data: function () {
    return {
      showEditStudent: false,
      currentStudent: {},
      editStudentByTeacher: true,
      studentId: 0,
      showConfirmDeleteModal: false,
      success: false
    }
  },
  mounted: function () {
    this.getStudentsFromClass()
  },
  computed: {
    studentList: function () {
      return this.$store.getters.studentList
    },
    emptyStudentList: function () {
      return this.studentList.length === 0
    }
  },
  watch: {
    selectedClass: function () {
      this.getStudentsFromClass()
    }
  },
  methods: {
    getStudentsFromClass: function () {
      this.$store.dispatch('getStudentsByClass', this.selectedClass.id).then(() => {
      }, (messages) => {
        this.handleError(messages)
      })
    },
    goToConnectedUser: function (username) {
      this.$router.push({ name: 'profile', params: { username } })
    },
    editStudent: function (student) {
      this.showEditStudent = true
      this.currentStudent = student
    },
    doneEditStudent: function () {
      this.showEditStudent = false
    },
    showRemoveStudentModal: function (student) {
      this.studentId = student.id
      this.showConfirmDeleteModal = true
    },
    removeStudent: function () {
      this.$store.dispatch('removeGroupUser', this.studentId).then((success) => {
        if (success) {
          this.getStudentsFromClass()
          this.showConfirmDeleteModal = false
          this.studentId = 0
        }
      }, (error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.student-card_container {
  max-width: 940px;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  @include touch {
    justify-content: center;
  }
}

.class-empty-modal {
  font-family: cera-pro;
  max-width: 60rem;
  margin: 3rem auto;
  padding: 3rem 12rem;
  background-color: white;
  text-align: center;
  border-radius: 2rem;
  box-shadow: 0px 2px 3px 1px #d2d2d2;
  @include touch {
    padding: 2rem 6rem;
  }
  @include mobile {
    padding: 1rem 1.3rem;
  }
  &_heading {
    font-size: 1.8rem;
    font-weight: 800;
    margin: 0.75rem 0;
    @include mobile {
      font-size: 1.3rem;
    }
  }
  &_text {
    margin: 0.75rem 0;
    font-size: 1.2rem;
    line-height: 1.8rem;
    @include mobile {
      font-size: 1rem;
    }
  }
  &_button {
    margin: 0.75rem;
    padding: 1.6rem 2.8rem;
  }
}

.user {
  &-fullName {
    color: black;
    font-size: 1rem;
    font-weight: 600;
  }
  &-userName {
    font-size: 0.75rem;
    font-weight: 400;
  }
}

.button-icon-container {
  position: absolute;
  display: flex;
  bottom: 39%;
  left: 5%;
  width: 100%;
  justify-content: center;
  span {
    margin-right: 0.5rem;
  }
}
.edit a {
  color: white;
}

.empty-student-message {
  text-align: center;
}

i.action-icon {
  display: block;
  border-radius: 60px;
  padding: 0.5em 0.6em;
  color: white;
}

i.delete-icon {
  background-color: $primary;
  &:hover {
    box-shadow: 0 0rem 1rem white;
    font-size: 0.95rem;
  }
}

.edit-icon {
  background-color: black;
  margin-right: 0.5rem;
  &:hover {
    box-shadow: 0 0rem 1rem white;
    font-size: 0.95rem;
  }
}
</style>
